export type GetImageUrlOptions = {
  width?: number
  height?: number
  isBlur?: boolean
  fit?: 'contain' | 'cover'
}

export function getImageUrl(url = '', options?: GetImageUrlOptions) {
  if (!url) return 'https://via.placeholder.com/150'
  if (!url.includes('flecto.cloud')) return url
  let newUrl = String(url)

  extractDynamicPart(newUrl)
    .split(',')
    .forEach((item) => {
      newUrl = newUrl.replaceAll(`${item},`, '')
      newUrl = newUrl.replaceAll(`${item}`, '')
    })

  const newParams: string[] = []
  if (options?.width) {
    newParams.push(`w=${options?.width}`)
  }
  if (options?.height) {
    newParams.push(`h=${options?.height}`)
  }
  if (options?.fit) {
    newParams.push(`fit=${options?.fit}`)
  } else {
    newParams.push('fit=contain')
  }

  if (options?.isBlur) {
    newParams.push('blur=80')
  }

  newUrl = newUrl.replace(/\/+$/, '')

  if (!newUrl.startsWith('https') || !newUrl.startsWith('http')) {
    newUrl = `https://${newUrl}`
  }

  return `${newUrl}/${newParams.join(',')}`
}

function extractDynamicPart(inputString: string): string {
  const regex = /(w|h|fit)=\w+/g
  const dynamicPartArray = inputString.match(regex)
  const dynamicPart = dynamicPartArray ? dynamicPartArray.join(',') : ''
  return dynamicPart
}
